module.exports = __webpack_public_path__ + "static/lova-dd549f7020c88ec86b47a91870d6536c.png";